import useModalClickOutside from "utils/useModalClickOutside";
import { useTranslation } from "next-i18next";
import BottomModal from "components/common/Modal/BottomModal";
import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import { TYPO } from "styles/Typo";
import Button from "components/common/buttons/buttons";
import { useRouter } from "next/router";
import { STRATEGY_META, STRATEGY_TYPE } from "utils/constant/STATUS";

function StrategyInfoModal({
  setModalOpen,
  isModalOpen,
  sCode,
}: {
  setModalOpen: any;
  isModalOpen: "risk" | "recommand" | boolean;
  sCode: STRATEGY_TYPE;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { t } = useTranslation("main");
  const router = useRouter();
  return (
    <BottomFloatingModal
      isOpen={!!isModalOpen}
      modalRef={modalRef}
      containerClass=""
      isIosFixedBottomButtonFlag={false}
    >
      <div className="min-h-[150px] flex flex-col gap-5 w-full">
        {isModalOpen === "risk" && (
          <>
            <div className="flex flex-col gap-4">
              <p className={`${TYPO.TYPO4_SB} text-gray90 px-6 pt-5`}>
                하락 리스크
              </p>
              <p
                className={`${TYPO.TYPO6_RG} text-gray70 px-6 custom-word-break`}
              >
                하루에 발생 가능한 손실의 최대치를 의미해요. 전략을 따라
                매수한다면 이정도 일간 손실은 염두하고 투자해야 해요.
              </p>
            </div>
            <div className="px-6 pb-6">
              <Button
                size="md"
                text={router.locale === "ko" ? "확인" : "Confirm"}
                clickHandler={() => setModalOpen(!isModalOpen)}
                type={"primary"}
                width="w-full"
              />
            </div>
          </>
        )}
        {isModalOpen === "recommand" && (
          <>
            <div className="flex flex-col gap-4">
              <p className={`${TYPO.TYPO4_SB} text-gray90 px-6 pt-5`}>
                {router.locale === "ko"
                  ? STRATEGY_META[sCode].recommandType
                  : STRATEGY_META[sCode].recommandTypeEng}
              </p>
              <div className="flex flex-col gap-1">
                <p
                  className={`${TYPO.TYPO6_RG} text-gray70 px-6 custom-word-break`}
                >
                  {router.locale === "ko"
                    ? STRATEGY_META[sCode].recommandContentDesc1
                    : STRATEGY_META[sCode].recommandContentDescEng1}
                </p>
                <p
                  className={`${TYPO.TYPO6_RG} text-gray70 px-6 custom-word-break`}
                >
                  {router.locale === "ko"
                    ? STRATEGY_META[sCode].recommandContentDesc2
                    : STRATEGY_META[sCode].recommandContentDescEng2}
                </p>
              </div>
            </div>
            <div className="px-6 pb-6">
              <Button
                size="md"
                text={router.locale === "ko" ? "확인" : "Confirm"}
                clickHandler={() => setModalOpen(!isModalOpen)}
                type={"primary"}
                width="w-full"
              />
            </div>
          </>
          // <div className="py-2 flex flex-col gap-3 w-full">
          //   <div className="gap-3 items-center flex cursor-pointer w-full">
          //     <div className="flex flex-col justify-center items-center w-full">
          //       <span className={`${TYPO.TYPO5_1_SB}  text-gray80 `}>
          //         {"“"}
          //         {router.locale === "ko"
          //           ? STRATEGY_META[sCode].recommandSubtitle
          //           : STRATEGY_META[sCode].recommandSubtitleEng}
          //         {"”"}
          //       </span>
          //     </div>
          //   </div>
          //   <div className={` w-full`}>
          //     <div className=" py-2  flex flex-col w-full">
          //       <div className=" flex flex-col gap-[5px] border-gray15 box-content">
          //         <span className={`${TYPO.TYPO7_RG} text-gray60 break-keep`}>
          //           {router.locale === "ko"
          //             ? STRATEGY_META[sCode].recommandContentDesc1
          //             : STRATEGY_META[sCode].recommandContentDescEng1}
          //         </span>
          //         <span className={`${TYPO.TYPO7_RG} text-gray60 break-keep`}>
          //           {router.locale === "ko"
          //             ? STRATEGY_META[sCode].recommandContentDesc2
          //             : STRATEGY_META[sCode].recommandContentDescEng2}
          //         </span>
          //         <span className={`${TYPO.TYPO7_RG} text-gray40`}>
          //           {router.locale === "ko"
          //             ? STRATEGY_META[sCode].recommandContentTitle
          //             : STRATEGY_META[sCode].recommandContentTitleEng}
          //         </span>
          //       </div>
          //     </div>
          //   </div>
          //   <Button
          //     size="md"
          //     text={router.locale === "ko" ? "확인" : "Confirm"}
          //     clickHandler={() => setModalOpen(!isModalOpen)}
          //     type={"primary"}
          //     width="w-full"
          //   />
          // </div>
        )}
      </div>
    </BottomFloatingModal>
  );
}

export default StrategyInfoModal;
